(function ($) {
  Drupal.behaviors.pcem_layout_3 = {
    attach: function (context, settings) {
      $('#content', context).once('pcem_layout_3', function () {
        // Hide/show the outline of the buttons && aniamte the left contents.
        var animFinished = false;
        // Check for ipad
        // Check for iPad.
        var isTouch = false;

        if (navigator.userAgent.match(/iPad/i) != null) {
          isTouch = true;
          $('body').addClass('isTouch');
        }

        // image animations
        var model3Loop;
        var imageCounterModel3 = 1;

        function image3Loop() {
          model3Loop = setInterval(function () {
            if (imageCounterModel3 < 4) {
              imageCounterModel3++;
              $('.pc_em_model_img_src3').removeClass('imageShow');
              $('.pc_em_model_img_src3').addClass('imageHide');
              $('.pc_em_model3_img' + imageCounterModel3).removeClass('imageHide');
              $('.pc_em_model3_img' + imageCounterModel3).addClass('imageShow');
            } else {
              imageCounterModel3 = 1;
              $('.pc_em_model_img_src3').removeClass('imageShow');
              $('.pc_em_model_img_src3').addClass('imageHide');
              $('.pc_em_model3_img' + imageCounterModel3).removeClass('imageHide');
              $('.pc_em_model3_img' + imageCounterModel3).addClass('imageShow');
            }
          }, 2000);
        }

        image3Loop();
        $('.pcem_layout_3 .pc_em_swatch_dots_wrapper').hover(
          function (e) {
            clearInterval(model3Loop);
            var findElem = $(this).parent().parent().find('.pc_em_lipsticks_wrapper');
            var thisModelAnim = findElem.find('.pc_em_model_img .pc_em_model_img_overlay');

            thisModelAnim.addClass('hovered');
            $('.pcem_layout_3 .pc_em_swatch_img_src_active.front').css({
              opacity: 1
            });
          }, // over
          function (e) {
            image3Loop();
            var findElem = $(this).parent().parent().find('.pc_em_lipsticks_wrapper');
            var thisModelAnim = findElem.find('.pc_em_model_img .pc_em_model_img_overlay');

            thisModelAnim.removeClass('hovered');
            $('.pcem_layout_3 .pc_em_swatch_img_src_active.front').css({
              opacity: 0
            });
          } // out
        );

        // Swatch Animations
        // Hide/show the outline of the buttons && aniamte the left contents.
        var animFinished = false;

        function hoverOutline(outlineNo) {
          if (animFinished === false) {
            $('.pc_em_swatch_dots.pc_em__3_swatch_dot_' + outlineNo).hover(
              // On hover

              function () {
                animFinished = true;
                $(this).siblings('.pc_em__3_swatch_dot_' + outlineNo + '.pc_em_swatch_dots_active').addClass('pc_em_swatch_selected').siblings('.pc_em_swatch_dots_active').removeClass('pc_em_swatch_selected');

                var findElem = $(this).parent().parent().parent().find('.pc_em_lipsticks_wrapper');

                $('#pc_em_swatch_shades_label_3').find(
                  '#pc_em_swatch_label_' + outlineNo
                ).stop(false, false).animate({
                  opacity: '1'
                }, 250);

                var thisSwatchAnim = findElem.find('.pc_em_swatch_img_src_' + outlineNo + '.back');
                var thisSwatchAnimFront = findElem.find('.pc_em_swatch_img_src_' + outlineNo + '.front');
                var thisLipsticksAnim = findElem.find('.pc_em_lipsticks_img_src.pc_em_lipsticks_img_src_' + outlineNo);

                thisSwatchAnimFront.addClass('pc_em_swatch_img_src_active');
                thisSwatchAnimFront.css({
                  opacity: '1'
                });
                thisSwatchAnimFront.siblings().removeClass('pc_em_swatch_img_src_active');
                thisSwatchAnimFront.siblings().css({
                  opacity: '0'
                });

                thisSwatchAnim.css({
                  opacity: 1
                });

                thisSwatchAnimFront.css({
                  opacity: 1
                });

                thisLipsticksAnim.css({
                  opacity: 1
                });

                thisLipsticksAnim.siblings().css({
                  opacity: 0
                });
              },
              // Off hover
              function () {
                $('#pc_em_swatch_shades_label_3').find(
                  '#pc_em_swatch_label_' + outlineNo
                ).stop(true, false).animate({
                  opacity: '0'
                }, 250);

                var findElem = $(this).parent().parent().parent().find('.pc_em_lipsticks_wrapper');
                var thisSwatchAnim = findElem.find('.pc_em_swatch_img_src_' + outlineNo + '.back');
                var thisSwatchAnimFront = findElem.find('.pc_em_swatch_img_src_' + outlineNo + '.front');
                var thisLipsticksAnim = findElem.find('.pc_em_lipsticks_img_src.pc_em_lipsticks_img_src_' + outlineNo);

                thisLipsticksAnim.siblings().css({
                  opacity: 0
                });
                thisSwatchAnim.stop(true, true).animate({
                  opacity: 1
                }, 10, 'easeInOutQuad').siblings().animate({
                  opacity: 0
                }, 10, 'easeInOutQuad');
              }
            );
          }
        }

        function swatchClick(outlineNo) {
          $('.pc_em_swatch_dots.pc_em__3_swatch_dot_' + outlineNo).on('click', function () {
            var qsBtn = $(this).parent().parent().find('.pc_em_swatch_qs .quick_shop');

            qsBtn.trigger('click');
            var dataskubaseid = $(this).attr('data-sku-base-id');

            if (!dataskubaseid) {
              dataskubaseid = 0;
            }
            setTimeout(function () {
              $('li.swatches--single a.swatch[data-sku-base-id="' + dataskubaseid + '"]').trigger('click');
            }, 350);
          });
        }
        for (i = 1; i <= 16; i++) {
          swatchClick(i);
        }

        for (i = 1; i <= 16; i++) {
          // showOutline(i);
          hoverOutline(i);
        }
      });
    }
  };
})(jQuery);
